import { e as r, c as n } from "./extend-tailwind-merge-e63b2b56.js";
const t = r({
  prefix: "dhs-"
});
function o(...e) {
  return t(n(e));
}
export {
  o as cn
};
